import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import VitalSigns from '../components/VitalSigns'
import Iframe from 'react-iframe'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  page: {
    height: 'calc(100% - 90px)',
    width: '100%',
    overflow: 'scroll'
  },
  iFrame: {
    left: 0,
    zIndex: 10000
  },
  flex: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  section: {
    padding: '40px 60px'
  },
  header: {
    fontSize: '1.5rem',
    marginBottom: 20
  },
  closeButton: {
    position: 'absolute',
    top: 15,
    right: 15
  }
}

class VitalSignsPage extends Component {
  constructor (props) {
    super(props)
  }

  renderIFrame () {
    const { classes } = this.props
    return (
      <Iframe url={this.props.patient.ecg_url}
        className={classes.iFrame}
        width="100%"
        height="100%"
        id="grafana"
        display="initial"
        position="relative"
      />
    )
  }

  render () {
    const { classes, patient } = this.props
    const { temperature, temperature_url, ecg, ecg_url, respiratory, respiratory_url } = patient
    if (!patient) return <div/>
    return (
      <div className={classes.page}>
        { this.renderIFrame() }
      </div>
    )
  }
}

export default withStyles(styles)(VitalSignsPage)



// WEBPACK FOOTER //
// ./src/pages/VitalSigns.js